import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "shirt-gradient_svg__svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<defs><linearGradient id=\"shirt-gradient_svg__a\" x1=\"0%\" x2=\"0%\" y1=\"0%\" y2=\"100%\"><stop offset=\"0%\" style=\"stop-color:rgba(255,255,255,.08);stop-opacity:1;\"></stop><stop offset=\".01%\" style=\"stop-color:rgba(255,255,255,.3);stop-opacity:1;\"></stop><stop offset=\"100%\" style=\"stop-color:rgba(255,255,255,.1);stop-opacity:1;\"></stop></linearGradient></defs><path fill=\"url(#shirt-gradient_svg__a)\" d=\"M4.5 3v9c-3 0-4-1-4.5-2l4.5-7ZM9 3c0 1.5 1.5 3.5 3 4 1.5-.5 3-2.5 3-4h3v17s-1.5 1-6 1-6-1-6-1V3h3ZM19.5 12V3l4.5 7c-.5 1-1.5 2-4.5 2Z\"></path>", 2)
  ]))]))
}
export default { render: render }